import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  CATEGORY_CONSTANTS,
  MenuItemComponentType
} from "../../../../../constants/index.js";
import { MenuActionCreators } from "../../../../../redux/action-creators/index.js";
import { MenuSelectors } from "../../../../../redux/selectors/index.js";
import { useKambiCategoryItems } from "./useKambiCategoryItems.js";
import { TrackingInfo } from "../../../../tracking/TrackingInfoMenu.js";

export const useKambiMenuItemsMobile = () => {
  const { sportCategories, visibleCategories, hiddenCategories } =
    useKambiCategoryItems();
  const menuItems = useSelector(MenuSelectors.menuItems);
  const numberOfDisplayedItems = useSelector(
    MenuSelectors.numberOfDisplayedItems
  );
  const dispatch = useDispatch();

  useEffect(() => {
    const handleMenuItemClick = () => {
      dispatch(MenuActionCreators.hideHamburgerMenu());
    };

    const quickLinkItems = getMobileKambiMenuItems(
      visibleCategories,
      handleMenuItemClick
    );

    if (
      sportCategories?.length > CATEGORY_CONSTANTS.NUMBER_OF_ITEMS_MOBILE_LOW
    ) {
      quickLinkItems.push({
        key: "menu-item-show-more-less",
        props: { trackingInfo: TrackingInfo },
        componentType: MenuItemComponentType.KambiMobileExpandMenuItem
      });
    }

    if (quickLinkItems && quickLinkItems.length) {
      dispatch(MenuActionCreators.setMenuItems(quickLinkItems));
    }
  }, [
    dispatch,
    sportCategories?.length,
    visibleCategories,
    hiddenCategories,
    numberOfDisplayedItems
  ]);

  return menuItems;
};

const getMobileKambiMenuItems = (menuCategories, handleMenuItemClick) => {
  let menuItemsList = menuCategories.slice();
  let categories = [];
  for (let item of menuItemsList) {
    const hasChildren = item.items?.length > 0;
    const componentType = hasChildren
      ? MenuItemComponentType.ExpandableSportCategoryMenuItemMobile
      : MenuItemComponentType.SportCategoryMenuItem;

    const menuItem = {
      key: `menu-item-${item.fullURL}-${item.ID || item.sportID}`,
      props: {
        item,
        dataTestId: item.termKey,
        trackingInfo: TrackingInfo,
        onClick: (!hasChildren && handleMenuItemClick) || undefined
      },
      componentType
    };

    categories.push(menuItem);
  }
  return categories;
};
